import { writable } from 'svelte/store'

import { WEEK_DEFAULT_STATE } from '../config'

const week = writable(WEEK_DEFAULT_STATE)

export default week